import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IAlertDialog } from './type';

export default function AlertDialog(props: IAlertDialog) {
  const { open, onClose, onDelete } = props;

  return (
    <div>
      <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Are you sure , you want to delete it ?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Once deleted, it cannot be retrieved.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onClose}>
            No
          </Button>
          <Button variant="contained" onClick={onDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
